import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ForWho } from './components/ForWho';
import { SystemOverview } from './components/SystemOverview';
import { FourParts } from './components/FourParts';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { PremiumDetails } from './components/PremiumDetails';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
const META_PIXEL_ID = '1981559035779813';
export function App() {
  useEffect(() => {
    // Prevent duplicate initialization (e.g. on Strict Mode double-mount)
    if (typeof window === 'undefined') return;
    if ((window as any).__metaPixelLoaded) return;
    (window as any).__metaPixelLoaded = true;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any;
      let t: HTMLScriptElement;
      let s: HTMLScriptElement | null;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
      s && s.parentNode && s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    const fbq = (window as any).fbq;
    if (fbq) {
      fbq('init', META_PIXEL_ID);
      fbq('track', 'PageView');
    }
    // <noscript> fallback for users with JS disabled
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    img.alt = '';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
  }, []);
  return <main className="w-full min-h-screen bg-cream text-plum font-sans overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <ForWho data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <FourParts data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <Pricing data-id="element-9" />
      <PremiumDetails data-id="element-10" />
      <Guarantee data-id="element-11" />
      <FAQ data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchaseNotification data-id="element-15" />
    </main>;
}